"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Indicator = exports.Wrapper = exports.Header = exports.IconWrapper = exports.Label = exports.Description = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _framerMotion = require("framer-motion");

var _Typography = require("../Typography");

var _textStyles = require("../../styles/textStyles");

var Description = (0, _styled.default)(_framerMotion.motion.p)(function (_ref) {
  var space = _ref.theme.space;
  return {
    margin: 0,
    fontSize: '1.2rem',
    lineHeight: '1.2',
    marginBottom: space.small
  };
});
exports.Description = Description;
var Label = (0, _styled.default)(_Typography.Body)(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      colors = _ref2$theme.colors,
      fonts = _ref2$theme.fonts,
      mediaQueries = _ref2$theme.mediaQueries,
      navItem = _ref2$theme.navItem,
      enhanced = _ref2.enhanced;
  return _objectSpread(_objectSpread({}, enhanced ? _objectSpread(_objectSpread({
    fontFamily: fonts.bold
  }, _textStyles.bodySize.small), {}, _defineProperty({}, mediaQueries.xlarge, _objectSpread({}, _textStyles.bodySize.medium))) : _objectSpread(_objectSpread({
    fontFamily: fonts.body
  }, _textStyles.bodySize.xsmall), {}, _defineProperty({}, mediaQueries.xlarge, _objectSpread({}, _textStyles.bodySize.small)))), {}, {
    display: 'inline-block',
    transition: 'color 0.3s ease-in-out',
    lineHeight: '1.2',
    color: colors.primary,
    marginBottom: 0,
    padding: 0,
    '&:hover': _defineProperty({}, mediaQueries.untilLarge, {
      color: colors[navItem.accentColor]
    })
  });
}); // The indicator icon is not visible on mobile devices due to tap vs hover

exports.Label = Label;
var IconWrapper = (0, _styled.default)(_framerMotion.motion.div)(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      mediaQueries = _ref3$theme.mediaQueries,
      space = _ref3$theme.space;
  return _defineProperty({
    display: 'none',
    position: 'relative',
    top: "-0.2rem",
    marginLeft: space.xsmall
  }, mediaQueries.small, {
    display: 'inline-block'
  });
});
exports.IconWrapper = IconWrapper;
var Header = (0, _styled.default)('div')(function (_ref5) {
  var space = _ref5.theme.space;
  return {
    position: 'relative',
    padding: "".concat(space.small, " 0"),
    display: 'inline-block',
    cursor: 'pointer'
  };
});
exports.Header = Header;
var Wrapper = (0, _styled.default)(_framerMotion.motion.div)(function (_ref6) {
  var space = _ref6.theme.space;
  return {
    position: 'relative',
    padding: "".concat(space.xsmall, " 0")
  };
}); // The indicator icon is not visible on mobile devices due to tap vs hover

exports.Wrapper = Wrapper;
var Indicator = (0, _styled.default)(_framerMotion.motion.div)(function (_ref7) {
  var _ref7$theme = _ref7.theme,
      colors = _ref7$theme.colors,
      mediaQueries = _ref7$theme.mediaQueries,
      navItem = _ref7$theme.navItem,
      space = _ref7$theme.space;
  return _defineProperty({
    display: 'none',
    position: 'absolute',
    left: 0,
    bottom: space.xsmall,
    height: '0.2rem',
    width: '100%',
    backgroundColor: colors[navItem.accentColor]
  }, mediaQueries.small, {
    display: 'block'
  });
});
exports.Indicator = Indicator;
var _default = Wrapper;
exports.default = _default;